<template>
  <div class="page black chiefwhip">

        <img id="head" src="../assets/chiefwhip.jpg" />

    <div id="text">
      <h1>Featured Artist: Chief Whip</h1>
      <p>Rock and roll 4 piece from Devon taking inspiration from the darker things in life.</p>
      <p>Check them out on <a href="https://www.youtube.com/channel/UC38jDBpmdrnlg-UWA0F-FRA/videos">Youtube</a> and <a href="https://www.facebook.com/chiefwhipband/">Facebook</a>.</p>
    </div>
    <div id="eps">
      <iframe width="100%" height="315" src="https://www.youtube.com/embed/Q3tAnWrOY70" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      <!-- <img src="../assets/chiefwhip-ep1.jpg">
      <img src="../assets/chiefwhip-ep2.jpg"> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChiefWhip'
}
</script>

<style scoped lang="scss">
.chiefwhip{

  display: grid;
  width:100%;
  min-height:80vh;
  grid-template-rows: 50vh 1fr;
  grid-template-columns: 2fr 1fr 2fr;
  padding:0;
  margin-top:50px;
  #head{
    grid-column: 1 / -1;
    grid-row: 1 / span 1;
    
      width:100%;
      height: 50vh;

      object-fit: cover;
      object-position: 50% 10%;

    
  }
  #text{
    grid-column: 1 / span 2;
    grid-row: 2 / -1;
    padding:2em;
  }
  h1{
    color:rgb(174, 51, 51);
  }
  #eps{
    text-align: right;
    img{
      object-fit:contain;
      width:100%;
      height:100%;
            max-width:185px;
      max-height:180px;
      
    }
  }
  #ep1{
    grid-column:3/-1;
    grid-row:2/-1;
  }
  a {
    color:lightcoral;
    font-weight: bold;
    text-decoration: none;
    &:hover{
      color:rgb(248, 166, 166);
      text-decoration: underline;
    }
  }
}
@media only screen and (max-width: 600px) {
.chiefwhip{
  #eps{
    grid-column:1/-1;
    grid-row: 2/span 1;
    text-align: center;
    
  }
  #text{
    grid-column: 1/-1;
    grid-row: 3 / span 1;
  }
}
}

</style>
